module.exports = __webpack_public_path__ + "img/sepa.a407b649.png";